var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('Table',{attrs:{"tableData":_vm.flattenedtabletData,"fields":_vm.fields,"sortBy":_vm.sortBy,"filterOn":_vm.filterOn,"filter-keys":['clientName', 'contractStatus', 'contractType']},on:{"rowClicked":_vm.rowClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }